import { render, staticRenderFns } from "./IconFontawesome5.vue?vue&type=template&id=ee7b97f6"
import script from "./IconFontawesome5.vue?vue&type=script&lang=js"
export * from "./IconFontawesome5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports